import React, {useState, useEffect, useRef} from 'react';
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import AddIcon from "@mui/icons-material/Add"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/DeleteOutlined"
import SaveIcon from "@mui/icons-material/Save"
import CancelIcon from "@mui/icons-material/Close"
import Typography from '@mui/material/Typography';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons
} from "@mui/x-data-grid"
import { randomId } from "@mui/x-data-grid-generator"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PaidIcon from '@mui/icons-material/Paid';
import { getDatabase, ref, get } from "firebase/database";
import { getAuth } from "firebase/auth";
import { app } from '../components/Firebase';
import CircularProgress from '@mui/material/CircularProgress';
import { Hidden } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { appCheck } from "../App";
import { getToken  } from "firebase/app-check";

function EditToolbar(props) {
  const { rows, setRows, rowModesModel, setRowModesModel, surveyBudget, surveyIds, setSurveyBudget, addDialogOpen, setAddDialogOpen, submitDialogOpen, setSubmitDialogOpen, confirmDialogOpen, setConfirmDialogOpen, errorDialogOpen, setErrorDialogOpen, hasRun, circleProg, setCircleProg, unsavedDialogOpen, setUnsavedDialogOpen, errorDialogMessage, setErrorDialogMessage, errorDialogTitle, setErrorDialogTitle } = props
  const handleAddDialogOpen = () => {
    setAddDialogOpen(true);
  };

  const handleAddDialogClose = () => {
    setAddDialogOpen(false);
  };

  function transformToSurveyRequestPackages(array) {
    return array.map(item => {
      const dateRequested = new Date().toDateString();
  
      return {
        dateRequested: dateRequested,
        emailAddress: item.email,
        status: "Requested",
        surveyId: item.surveyType,
        surveyTakerName: item.name,
        surveyVersion: 0
      };
    });
  }

  const handleAddRowClick = () => {
    if(circleProg)
    {
      return;
    }
    if (rows.length < surveyBudget) {
      const id = randomId()
      setRows(oldRows => [
        ...oldRows,
        { id: id, name: "", email: "", surveyType: surveyIds[0], isNew: true }
      ])
      setRowModesModel(oldModel => ({
        ...oldModel,
        [id]: { mode: GridRowModes.Edit, fieldToFocus: "name" }
      }))
    }
    else
    {
      handleAddDialogOpen();
    }
  }

  const handleSubmitDialogOpen = () => {
    setSubmitDialogOpen(true);
  };

  const handleSubmitDialogClose = () => {
    setSubmitDialogOpen(false);
  };

  const handleUnsavedDialogOpen = () => {
    setUnsavedDialogOpen(true);
  };

  const handleUnsavedDialogClose = () => {
    setUnsavedDialogOpen(false);
  };

  const handleConfirmDialogOpen = () => {
    setConfirmDialogOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  }

  const handleErrorDialogOpen = (error, finalStatus) => {
    let errorMessage = 'Survey Request submission failed. Check network connection or try again later.';
    let dialogTitle = 'Survey Request Error';
    if (finalStatus === 500) {
      errorMessage = 'Database update failed. Please try again or come back later.';
    } else if (finalStatus === 206) {
      errorMessage = 'Some emails failed to send. Please verify email addresses in the remaining survey requests.';
    } else if (finalStatus === 200) {
      errorMessage = 'All emails sent successfully.';
      dialogTitle = 'Success';
    }
    setErrorDialogMessage(errorMessage);
    setErrorDialogTitle(dialogTitle);
    setErrorDialogOpen(true);
  };

  const handleErrorDialogClose = () => {
    setErrorDialogOpen(false);
  }

  //submit survey requests
  const handleConfirmDialogSubmit = async (rows, hasRun) => {
    if(circleProg) {
      return;
    }
    setCircleProg(true);
    handleConfirmDialogClose();
    let successfulRows = [];
    let remainingRows = [...rows]; // Copy the rows
    let finalStatus = null;
  
    try {
      // Get the ID token of the current user.
      const idToken = await getAuth().currentUser.getIdToken();
      // Get a valid App Check token
      let appCheckTokenResponse;
      try {
        appCheckTokenResponse = await getToken(appCheck, true);
      } catch (err) {
        console.error("App Check token retrieval failed:", err);
        return; // Abort if unable to retrieve token
      }
      // Send a request to the Firebase Function
      const response = await fetch(`/requestSurvey`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'X-Firebase-AppCheck': appCheckTokenResponse.token
          },
          body: JSON.stringify({
            surveyRequestPacks: transformToSurveyRequestPackages(remainingRows)
          })
        });

      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}, message: ${responseJson.error}`);
      }

      successfulRows = responseJson.successfulRequests || [];
      // Remove the successful rows from the remaining rows
      remainingRows = remainingRows.filter((_, index) => !successfulRows.includes(index));

      finalStatus = responseJson.status;

    } catch (error) {
      console.warn('Error: ', error);
      // Open the dialog
      handleErrorDialogOpen(error, finalStatus);
      setCircleProg(false);
    }
    // Update rows with the remaining rows if submission succeeds
    setSurveyBudget(surveyBudget-successfulRows.length);
    setRows(remainingRows);
    setCircleProg(false);
    return successfulRows;
  };

  const handleSubmitClick = () => {
    if(circleProg)
    {
      return;
    }
    for(let id in rowModesModel)
    {
      if(rowModesModel[id].mode === GridRowModes.Edit)
      {
        handleUnsavedDialogOpen();
        return;
      }
    }    
    for(let r of rows)
    {
      //{ id: id, name: "", email: "", surveyType: surveyIds[0], isNew: true }
      if(!/^[a-zA-Z0-9\- .'b]{1,128}$/.test(r.name) || !/^[^@]+@[^@]+\.[^@]+$/.test(r.email))
      {
        handleUnsavedDialogOpen();
        return;
      }
    }
    if (!rows || rows.length === 0 || surveyBudget === 0)
    {
      handleSubmitDialogOpen();
    }
    else
    {
      handleConfirmDialogOpen();
    }
  }
  const color = rows.length < surveyBudget ? 'green' : `rgb(255, 55, 0)`;
  return (
    <GridToolbarContainer>
      <Button color="primary" startIcon={<AddIcon />} onClick={handleAddRowClick} variant="contained">
        Add Assessment
      </Button>
      <Box sx={{ bgcolor: 'background.paper', p: 2 }}>
          <Typography variant="h6" sx={{ color: 'primary.main', display: 'inline-block' }}>
              Assessment Budget:&ensp;
          </Typography>
          <Typography variant="body1" sx={{ display: 'inline-block', color }}>
            {rows.length}/{surveyBudget} {/* replace with your firebase balance variable */}
          </Typography>
      </Box>
      <Button color="primary" startIcon={<PaidIcon />} onClick={handleSubmitClick} variant="contained">
        Submit Requests
      </Button>
      <Hidden xsUp={!circleProg}>
            <CircularProgress color="success" m={10}/>
      </Hidden>
      <Dialog
          open={addDialogOpen}
          onClose={handleAddDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Assessment budget limit reached"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Assessment budget limit reached. Submit the current survey list, then purchase a new assessment package in the Product Selection tab.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAddDialogClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={unsavedDialogOpen}
          onClose={handleUnsavedDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Invalid Request"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Unconfirmed or unfinished rows detected. Please confirm or delete unfinished rows.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleUnsavedDialogClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={submitDialogOpen}
          onClose={handleSubmitDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Invalid Request"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            No assessment budget available, or no assessments requested. <br></br>
              Visit the Product Selection tab to increase your assessment budget.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmitDialogClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={errorDialogOpen}
          onClose={handleErrorDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {errorDialogTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {errorDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleErrorDialogClose} autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={confirmDialogOpen}
          onClose={handleConfirmDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm your order. <br/>
              Or, cancel to review.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmDialogClose} autoFocus>
              Cancel
            </Button>
            <Button onClick={() => handleConfirmDialogSubmit(rows, hasRun)} autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
    </GridToolbarContainer>
  )
}

export default function SurveyRequestTable() {

const [surveyBudget, setSurveyBudget] = useState(0);
const [surveyIds, setSurveyIds] = useState([]);
const [addDialogOpen, setAddDialogOpen] = React.useState(false);
const [submitDialogOpen, setSubmitDialogOpen] = React.useState(false);
const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
const [circleProg, setCircleProg] = React.useState(false);
const [unsavedDialogOpen, setUnsavedDialogOpen] = useState(false);
const [errorDialogMessage, setErrorDialogMessage] = React.useState('');
const [errorDialogTitle, setErrorDialogTitle] = React.useState('');
const hasRun = useRef(false);
const auth = getAuth();

const user = auth.currentUser;

useEffect(() => {
  if (hasRun.current) {
    return;
  }

  if (user && user.emailVerified) {
    const db = getDatabase();
    const refBudget = ref(db, `SurveyBudget/${user.uid}/budget`);
    get(refBudget).then((snapshot) => {
      setSurveyBudget(snapshot.val());
    });

    const refSurvey = ref(db, 'Survey');
    get(refSurvey).then((snapshot) => {
      const surveys = snapshot.val();
      if (surveys) {
        setSurveyIds(Object.keys(surveys));
      }
    });
  }
  else{
    console.log("User not authenticated, no budget pulled.");
  }
  hasRun.current = true;
}, []);

  const [rows, setRows] = React.useState([])
  const [rowModesModel, setRowModesModel] = React.useState({})

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true
    }
  }

  const handleEditClick = id => () => {
    if(circleProg)
    {
      return;
    }
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } })
  }

  const handleSaveClick = id => () => {
    if(circleProg)
    {
      return;
    }
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } })
  }

  const handleDeleteClick = (id) => () => {
    if(circleProg)
    {
      return;
    }
    setRows(rows.filter(row => row.id !== id))
  };

  const handleCancelClick = id => () => {
    if(circleProg)
    {
      return;
    }
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true }
    })

    const editedRow = rows.find(row => row.id === id)
    if (editedRow.isNew) {
      setRows(rows.filter(row => row.id !== id))
    }
  }

  const processRowUpdate = newRow => {
    const updatedRow = { ...newRow, isNew: false }
    setRows(rows.map(row => (row.id === newRow.id ? updatedRow : row)))
    return updatedRow
  }

  const handleRowModesModelChange = newRowModesModel => {
    setRowModesModel(newRowModesModel)
  }
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md'));
  const columns = [
    { field: "name", headerName: "Name", width: 180, editable: true, flex: 1  },
    { field: "email", headerName: "Email", width: 180, align: "left", headerAlign: "left", editable: true, flex: 1  },
    { field: "surveyType", headerName: "Survey Type", width: 220, editable: true, type: "singleSelect", valueOptions: surveyIds, flex: 1  },
    { field: "actions", type: "actions", headerName: "Actions", width: 100, cellClassName: "actions", flex: 1 , getActions: ({ id }) => {
      const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      if (isInEditMode) {
        return [
          <GridActionsCellItem icon={<span style={{ padding: '4px', fontSize: '16px', color: 'primary.main' }}>Confirm</span>} label="Confirm" sx={{ color: "primary.main" }} onClick={handleSaveClick(id)} />,
          <GridActionsCellItem icon={<CancelIcon />} label="Cancel" className="textPrimary" onClick={handleCancelClick(id)} color="inherit" />
        ];
      }
      return [
        <GridActionsCellItem icon={<span style={{ padding: '4px', fontSize: '16px', color: 'primary.main' }}>Edit</span>} label="Edit" className="textPrimary" onClick={handleEditClick(id)} color="inherit" />,
        <GridActionsCellItem icon={<DeleteIcon />} label="Delete" onClick={handleDeleteClick(id)} color="inherit" />
      ];
    } }
  ];

  return (
      <Box
        sx={{
          height: "64vh",
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          id="custom-datagrid"
          sx={{
            '& .MuiDataGrid-row': {
              flexWrap: 'wrap', // Adjusts rows dynamically
            }
            }}
          rows={rows}
          columns={columns}
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          disableColumnFilter
          disableColumnSorting={true}
          disableColumnMenu={true}
          slots={{
            toolbar: EditToolbar
          }}
          slotProps={{
            toolbar: { rows, setRows, rowModesModel, setRowModesModel, surveyBudget, surveyIds, setSurveyBudget, addDialogOpen, setAddDialogOpen, submitDialogOpen, setSubmitDialogOpen, confirmDialogOpen, setConfirmDialogOpen, errorDialogOpen, setErrorDialogOpen, hasRun, circleProg, setCircleProg, unsavedDialogOpen, setUnsavedDialogOpen, errorDialogMessage, setErrorDialogMessage, errorDialogTitle, setErrorDialogTitle },
          }}
        />
      </Box>
    )
}
